import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

//PAGES
import Products from "../pages/Products";
import ProductDetailPage from "../pages/Products/ProductDetailPage";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import BasicPasswReset from "../pages/Authentication/BasicPasswReset";
import SetPassword from "../pages/Authentication/SetPassword";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import Orders from "../pages/Orders";
import Resources from "../pages/Resources";
import HowToGetSupport from "../pages/Resources/how_get_support";
import ReserveUnits from "../pages/Products/ReserveUnits";
import Billing from "../pages/Billing";
import Subscription from "../pages/Authentication/subscription";
import QuickStart from "../pages/QuickStart";
import Subscribe from "../pages/Authentication/Subscribe";
import FreeRegister from "../pages/Authentication/FreeRegister";
import TrialWelcome from "../pages/TrialWelcome";

const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

const authProtectedRoutes = [
  { path: "/products", component: <Products /> },
  { path: "/products/:pro_id", component: <ProductDetailPage /> },
  { path: "/orders", component: <Orders /> },
  //{ path: "/reports", component: <DashboardAnalytics /> },
  { path: "/resources", component: <Resources /> },
  { path: "/resources/how-to-get-support", component: <HowToGetSupport /> },
  //{ path: "/settings", component: <Billing /> },
  { path: "/billing", component: <Billing /> },
  { path: "/placeOrder", component: <ReserveUnits /> },
  { path: "/billing", component: <Billing /> },
  { path: "/trial-welcome", component: <TrialWelcome /> },
  //User Profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/quickstart", component: <QuickStart /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/products" />,
  },
  { path: "*", component: <Navigate to="/products" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgotPassword", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/monthly", component: <Register /> },
  { path: "/free", component: <ExternalRedirect to="https://mybuyersclub.net/" /> },
  { path: "/passwordReset", component: <BasicPasswReset /> },
  { path: "/passwordSet", component: <SetPassword /> },
  { path: "/subscription", component: <Subscription /> },
  { path: "/subscribe", component: <Subscribe /> },
];

export { authProtectedRoutes, publicRoutes };
